import http from '../http'

export default {
  // 获取用户信息
  getMyAccountInfo(data: object, option: object = {}) {
    return http.post('/web/MyAccountInfo', data, option);
  },
}
